import React, { useState, useEffect } from 'react';
import TFFDialog from '../../styled-components/TFFDialog';
import TFFTypography from '../../styled-components/TFFTypography';
import { Box, FormControl, Select, MenuItem } from '@mui/material';
import { SourceType, SOURCE_NDC_X, SOURCE_NDC } from './types';

interface SourceSelectionDialogProps {
  isOpen: boolean;
  onCancel: () => void;
  onNext: (source: SourceType) => void;
}

const SourceSelectionDialog: React.FC<SourceSelectionDialogProps> = ({ isOpen, onCancel, onNext }) => {
  const [selectedSource, setSelectedSource] = useState<SourceType | ''>('');

  useEffect(() => {
    if (!isOpen) {
      setSelectedSource('');
    }
  }, [isOpen]);

  const handleNext = () => {
    if (selectedSource) {
      onNext(selectedSource);
    }
  };

  return (
    <TFFDialog
      dialogId="source-selection-dialog"
      header={
        <TFFTypography
          text="Import NDC/NDC-X PNR"
          variant="lead"
          size="large"
          fontWeight="bold"
        />
      }
      isOpen={isOpen}
      onCancel={onCancel}
      onConfirm={handleNext}
      confirmButton
      cancelButton
      groupFooterButtons
      confirmButtonText="Next"
      cancelButtonText="Cancel"
      confirmDisabled={!selectedSource}
    >
      <Box sx={{ padding: 3, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Box sx={{ width: '300px' }}>
          <TFFTypography text="Source" variant="lead" size="medium" fontWeight="semibold" />
          <FormControl fullWidth>
            <Select
              id="region-select"
              value={selectedSource}
              displayEmpty
              onChange={e => setSelectedSource(e.target.value as SourceType)}
            >
              <MenuItem value="" disabled>
                -- Select an option --
              </MenuItem>
              <MenuItem value={SOURCE_NDC}>NDC</MenuItem>
              <MenuItem value={SOURCE_NDC_X}>NDC-X</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </Box>
    </TFFDialog>
  );
};

export default SourceSelectionDialog;
